import React from "react";
import { Box } from "@mui/material";
import Topbar from "../../../../../../component/TopBar";
import MainBox from "../../../../container/MainBox";
import { Outlet } from "react-router";

function Machines() {
  return (
     <Box sx={{width:"100%"}}>
        <Topbar MainHeading={"Machines"}/>
        <MainBox sx={{ padding: "2rem 1.25rem" }}>
              <Outlet/>
        </MainBox>
     </Box>
      
  );
}

export default Machines;
